import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ORDER_HISTORY_ROUTE } from "../../../modules/constants";
import { MessageScreen } from "modules/controls/components/MessageScreen";
import { fetchUser as fetchUserCreator } from "modules/userContext/userContext.actions";

const SuccessPageBody =
  window.i2290settings && window.i2290settings.SuccessPageBody;

const PaymentSuccessScreen = ({ history, fetchUser }) => {
  useEffect(() => {
    fetchUser();
    // only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickOK = () => {
    history.push(ORDER_HISTORY_ROUTE);
  };

  return (
    <MessageScreen onClickOK={handleClickOK}>
      <div
        className="mb-gutter"
        dangerouslySetInnerHTML={{ __html: SuccessPageBody }}
      />
    </MessageScreen>
  );
};

const mapDispatchToProps = (dispatch) => ({
  fetchUser: () => dispatch(fetchUserCreator()),
});

export const PaymentSuccessScreenContainer = withRouter(
  connect(null, mapDispatchToProps)(PaymentSuccessScreen)
);
